import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import localeEn from './locales/en/translation.json';
import localeId from './locales/id/translation.json';
import localeEnPH from './locales/ph/translation.json';

i18n.use(initReactI18next).init({
  resources: {
    // Define your translations here
    'en-MY': {
      name: 'English',
      translation: localeEn,
    },
    'en-PH': {
      name: 'English',
      translation: localeEnPH,
    },
    en: {
      name: 'English',
      translation: localeEn,
    },
    'id-id': {
      name: 'Bahasa Indonesia',
      translation: localeId,
    },
    id: {
      name: 'Bahasa Indonesia',
      translation: localeId,
    },
    // Add more languages as needed
  },
  lng: localStorage.getItem('locale') ?? 'en-MY', // Default language
  fallbackLng: 'en-my',
});

export default i18n;
